export default __webpack_public_path__ + "static/media/ic_volunteer.519178e2.svg";